"use strict";

import angular from "angular";

import template from "./empty-integration-token.component.html";

import { AccountingEntity } from "../../../entity/AccountingEntity";
import { UserEntity } from "../../../entity/UserEntity";
import { User } from "../../../gateway/User/User";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { GetUserApiAppSecretUsecase } from "../../../usecases";

class EmptyIntegrationTokenComponent {
    accountingEntity = {};
    userEntity = {};
    appSecret = null;

    constructor($scope, toast) {
        this.$scope = $scope;
        this.toast = toast;

        this.User = new User();
    }

    $onInit() {
        if (this.accountingData) {
            this.initEntity();
            this.setAppSecret();
        }
    }

    initEntity() {
        if (this.accountingData) {
            this.accountingEntity = new AccountingEntity(this.accountingData);
            this.userEntity = new UserEntity(new UserDataAdapter().user());
        }
    }

    async setAppSecret() {
        if (!this.accountingEntity || !this.userEntity) {
            return;
        }

        try {
            const getUserApiAppSecretUsecase = new GetUserApiAppSecretUsecase();
            const appSecret = await getUserApiAppSecretUsecase.execute({
                accountingId: this.accountingEntity.props._id
            });
            this.appSecret = appSecret;
        } catch (error) {
            console.error("Erro ao obter App Secret:", error);
            this.appSecret = null;
        }

        this.$scope.$applyAsync();
    }

    onClipBoard() {
        if (this.appSecret) {
            navigator.clipboard
                .writeText(this.appSecret)
                .then(() => {
                    console.log(
                        "App Secret copiado para a área de transferência"
                    );
                })
                .catch((err) => {
                    console.error("Erro ao copiar o App Secret:", err);
                });
            const snackbar = {
                message: "App Secret copiado!",
                cancel: () => {
                    this.toast.hide();
                },
                buttons: {},
                after: {},
                extOptions: {
                    hideDelay: 3000
                }
            };
            this.toast.snackbar(snackbar);
        }
    }
}

export { EmptyIntegrationTokenComponent };

EmptyIntegrationTokenComponent.$inject = ["$scope", "toast"];

const name = "emptyIntegrationTokenComponent";
const def = {
    controller: EmptyIntegrationTokenComponent,
    bindings: {
        accountingData: "<",
        logo: "<",
        integrationName: "<",
        helpLink: "<"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
